module.exports = __webpack_public_path__ + "img/20200414.a9440515.png";